import { useApp, useTranslation } from "@next-platform/client-common-core";
import { Text, TextVariants } from "@next-platform/client-common-spicy-ui";

import PageStaticMetaTags from "@/components/common/PageStaticMetaTags";
import { Col, Row } from "@/components/customComponents";
import useDownloadMobileApplicationsConfig from "@/features/mobileApplications/useDownloadMobileApplicationsConfig";
import { useTheme } from "@/hooks";
import { NotFound } from "@/pages";

import ApplicationCard from "./ApplicationCard";
import { getApplicationCardDetails, getSupportedAppsHeaderDetails } from "./utils";

export default function SupportedApplications() {
  const { applicationId, applicationName, branding } = useApp();
  const { brandedApplications, hasMobileApplications, isMobileApplicationsReady } = useDownloadMobileApplicationsConfig();
  const { isDark } = useTheme();
  const { t } = useTranslation();
  const { title, description } = getSupportedAppsHeaderDetails({ applicationId: applicationId ?? "", t, applicationName: applicationName });
  const applicationCards = getApplicationCardDetails({
    applicationId: applicationId ?? "",
    applicationName,
    brandedApplications,
    brandingLogo: branding?.logo ?? undefined,
    isDark,
    t,
  });

  if (!isMobileApplicationsReady) {
    return <div data-testid="SupportedApplications-Loading" />;
  }

  if (!hasMobileApplications) {
    return <NotFound />;
  }

  return (
    <Col className="supportedApplicationsPage items-center gap-10" data-testid="SupportedApplications">
      <PageStaticMetaTags pageId="supportedApplications" />
      <Col className="text-center w-[850px] max-w-full gap-4 mt-10">
        <Text variant={TextVariants.HEADING_LARGE_BOLD} centered as="h1" className="my-0 tracking-[0.01em] max-[767px]:text-heading-3">
          {title}
        </Text>
        <Text as="span" variant={TextVariants.PARAGRAPH_LARGE_REGULAR} centered className="leading-[1.15em]">
          {description}
        </Text>
      </Col>

      <Row className="gap-6 w-full max-desktop:flex-col justify-center">
        {applicationCards.map((appCardData) => (
          <ApplicationCard key={appCardData.id} appCardData={appCardData} />
        ))}
      </Row>
    </Col>
  );
}
